import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClientContextService } from '@sdbn/appclient';
import { DialogService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { MasterDetailListEntry } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { AccountInfoService } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Catalog } from '../../catalog.model';
import { AddCatalogDialogComponent } from '../add-catalog-dialog/add-catalog-dialog.component';
import { AddCatalogNodeDialogComponent } from '../add-catalog-node-dialog/add-catalog-node-dialog.component';

@Component({
  selector: 'app-catalog-admin',
  templateUrl: './catalog-admin.component.html',
  styleUrls: ['./catalog-admin.component.scss']
})
export class CatalogAdminComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  articleSearchListEntry = new Catalog({name: {dictionaryKey: 'Search', values: [{language: 'de', value: 'Suche'}, {language: 'en', value: 'Search'}, {language: 'fr', value: 'Search'}, {language: 'it', value: 'Search'}]}});
  data = new Array<Catalog>();

  selected: Catalog;
  selectedId: number;

  manageCatalogPermitted = false;

  constructor(
    private accountInfoService: AccountInfoService,
    private clientContextService: ClientContextService,
    public translationService: TranslationService,
    private dialogService: DialogService,
    private http: HttpService
  ) {

    super();

  }

  ngOnInit(): void {
    this.translationService.languageSubject.subscribe(newLanguage => {
      this.data.forEach(catalog => {
        catalog.calculateTitle(this.translationService.language);
      });
    });
    if (this.checkUserHasPrivilegeManageCatalog()) {
      this.manageCatalogPermitted = true;
      this.articleSearchListEntry.calculateTitle(this.translationService.language);
      this.readCatalogData();
    } else {
      this.dialogService.showInfoDialog('shared.tmc-http-interceptor.error.403.title',
          'shared.tmc-http-interceptor.error.403.message');
    }


  }

  public readCatalogData() {

    this.selectedId = this.selected != null ? this.selected?.id : null;

    this.http.postWithContext<Catalog[]>(environment.erpCatalogEndpoint + '/getAllCatalogs', {}).subscribe(response => {
      console.log('response is', response);

      let data = new Array<Catalog>();

      data.push(this.articleSearchListEntry);

      for (let catalog of response) {
        const c = new Catalog(catalog);
        c.calculateTitle(this.translationService.language);
        data.push(c);
      }
      this.data = data;

      this.restoreSelection();

      console.log(data);

    }, error => {
      console.log('error is', error);
    });

  }

  restoreSelection() {
    let selected: Catalog = null;

    if (this.selectedId != null) {
      for (let catalog of this.data) {
        if (catalog.id === this.selectedId) {
          selected = catalog;
        }
      }
    }

    if (selected == null && this.data.length > 0) {
      selected = this.data[0];
    }

    this.selected = selected;
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    this.selected = entry as Catalog;
  }

  onAddEntry(value: any) {
    console.log(value);
    this.dialogService.openDefault(AddCatalogDialogComponent, {}).afterClosed(

    ).subscribe(() => {

      this.readCatalogData();

    });
  }

  onDeleteEntry(entry: MasterDetailListEntry) {
    if (entry === this.articleSearchListEntry) {
      return;
    }
    const dialogRef = this.dialogService.showConfirm('erp.ui.delete-catalog.title', 'erp.ui.delete-catalog.message');
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed === true) {
        this.http.postWithContext<Catalog[]>(environment.erpCatalogEndpoint + '/deleteCatalog', {catalogId: this.selected.id}).subscribe(response => {
          console.log('deleteCatalog response is', response);
          this.readCatalogData();
        });
      }
    });
  }

  addRootNode() {
    this.dialogService.openDefault(AddCatalogNodeDialogComponent, { catalogId: this.selected.id, parentNodeId: null }).afterClosed(

    ).subscribe(() => {

      this.readCatalogData();

    });
  }


  private checkUserHasPrivilegeManageCatalog(): boolean {
    const yardKey = this.clientContextService.getCurrentContext()?.unit?.key;
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'erp_manage_basicarticle');
  }

}
